<div class="context-select">
  <div class="card">
    @if(step === 'scope'){
    <span class="title-text">Select scope</span>
    <p class="small-title">You have access at both the central (global) level and specific establishments. Choose how you want to work.</p>
    <div class="options">
      <button type="button" class="option-btn" (click)="chooseGlobal()">
        <span class="option-title">Global</span>
        <span class="option-sub">Central / all-branch access</span>
      </button>
      <button type="button" class="option-btn" (click)="chooseEstablishmentScope()">
        <span class="option-title">Establishment</span>
        <span class="option-sub">Work within a specific establishment</span>
      </button>
    </div>
    }

    @if(step === 'establishment'){
    <span class="title-text">Select establishment</span>
    <p class="small-title">Choose the establishment you want to work in.</p>
    <div class="options">
      @for(est of establishments; track est.establishmentId){
      <button type="button" class="option-btn" (click)="chooseEstablishment(est.establishmentId)">
        <span class="option-title">{{ est.estName || ('Establishment ' + est.establishmentId) }}</span>
        @if(est.code){ <span class="option-sub">{{ est.code }}</span> }
      </button>
      }
    </div>
    }
  </div>
</div>
